import type { BookingsSortColumn } from "../gql/graphql";
import type { FilterState } from "../services/booking-filter/filterReducer";
import { browserHistory } from "../store/utils/history";
import {
  urlGetSearchString,
  urlReplaceSearchString,
} from "../store/utils/urlModifier";
import type { URLHashData } from "./booking-filters/types";
import {
  parseManagePageUrl,
  stringifyManagePageUrlParams,
} from "./booking-filters/urlFilterState";

export const loadFilter = (): Partial<URLHashData> => {
  const searchString = urlGetSearchString(browserHistory);

  return parseManagePageUrl(searchString);
};

export const saveURLFilterData = (
  filter: FilterState,
  sorting: BookingsSortColumn,
) => {
  urlReplaceSearchString(
    browserHistory,
    stringifyManagePageUrlParams(filter, sorting),
  );
};
